import Testimonials from './Testimonials';

export default Testimonials;



// WEBPACK FOOTER //
// ./src/components/HomePage/components/Testimonials/index.js